import { ON_LOAD_PAYMENTS } from "../constants/payments";

const initialState = {};

export default function (state = initialState, action) {
  if (action.type == ON_LOAD_PAYMENTS) {
    return {
      ...state,
      ...action.payload
    };
  }
  return state;
}
